import React from "react";
import { useDrop } from "react-dnd";
import axios from "axios";
import toast from 'react-hot-toast';
import IconCollection from '../../IconCollection/IconCollection';
import SpinnerLoaderBlack from '../../Component/SpinnerLoaderBlack/SpinnerLoaderBlack';
import { gameSubs, submitPlayersAndMatchData, submitPlayersAndMatchDataWithOutPlaySec, teamTwoDraggedPlayerList, teamTwoPlayerDrop, teamTwoTargetPlayerList } from '../../redux/reducers/playersReducer';
import { useSelector } from 'react-redux';

const DroppableTeamTwoPlayer = ({
  player,
  onPlayerDrop,
  playerId,
  teamTwoColor,
  actionPlayerId,
  assistSelections,
  shortSelections,
  shortFieldSelections,
  event_team_b_id,
  event_id,
  event_group_id,
  quarter,
  minutes,
  seconds,
  token,
  matchData,
  playerPersonalFoulCount,
  handlePlayerSelectionTwo,
  dispatch,
  isLoadingTwo,
  setIsLoadingTwo,
  setDraggedPlayerTeamTwo,
  targetedPlayerTeamTwo,
  setTargetedPlayerTeamTwo,
  draggedPlayerTeamTwo
}) => {
  const handlePlayerTeamTwoDrop = async (draggedPlayer, targetPlayer) => {
    // Fix #5: Prevent self-substitution
    if (draggedPlayer.roster_id === targetPlayer.roster_id) return;

    setIsLoadingTwo(true);

    // Optimistic Redux update
    dispatch(teamTwoPlayerDrop({
      targetTeamTwoPlayer: targetPlayer.roster_id,
      draggedTeamTwoPlayer: draggedPlayer.roster_id,
    }));
    setTargetedPlayerTeamTwo(targetPlayer.jersey_number);
    setDraggedPlayerTeamTwo(draggedPlayer.jersey_number);

    // Fix #2: Add 20s timeout (matches bulk subs pattern)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 20000);

    try {
      // Step 1: Record substitution
      const data = new FormData();
      data.append("score_timer", minutes * 60 + seconds);
      data.append("event_id", event_id);
      data.append("eg_id", event_group_id);
      data.append("t_id", event_team_b_id);
      data.append("score_period", quarter);
      data.append("r_id_1_org", targetPlayer.roster_id);
      data.append("r_id_1_new", draggedPlayer.roster_id);

      const response = await fetch(
        `${process.env.REACT_APP_API_ROOT}/api/add_subs/`,
        { method: "POST", body: data, headers: { Authorization: `${token}` }, signal: controller.signal }
      );
      const result = await response.json();
      clearTimeout(timeoutId);

      if (result.error) {
        throw new Error(result.error);
      }

      dispatch(gameSubs(result.game_data.game_subs));

      // Step 2: Sync player status
      const draggedPlayerData = matchData?.team_b_rosters.find(p => p.roster_id === draggedPlayer.roster_id);
      const targetPlayerData = matchData?.team_b_rosters.find(p => p.roster_id === targetPlayer.roster_id);

      const statusData = [
        { r_id: draggedPlayer.roster_id, t_id: event_team_b_id, event_id, eg_id: event_group_id, present: true, startinglinup: true, play_sec: draggedPlayerData?.play_sec || 0 },
        { r_id: targetPlayer.roster_id, t_id: event_team_b_id, event_id, eg_id: event_group_id, present: true, startinglinup: false, play_sec: targetPlayerData?.play_sec || 0 },
      ];

      const formdata = new FormData();
      formdata.append("data", JSON.stringify(statusData));

      const statusResp = await axios.post(
        `${process.env.REACT_APP_API_ROOT}/api/playerStatus/`, formdata,
        { headers: { Authorization: `${token}` } }
      );

      if (statusResp.data.data !== null) {
        dispatch(submitPlayersAndMatchDataWithOutPlaySec(statusResp.data.data));
      }
      toast.success("Substitution successful");
    } catch (err) {
      clearTimeout(timeoutId);
      // Revert optimistic update — Fix #1: use err (not undefined error)
      dispatch(teamTwoPlayerDrop({
        targetTeamTwoPlayer: draggedPlayer.roster_id,
        draggedTeamTwoPlayer: targetPlayer.roster_id,
      }));
      // Fix #4: Show meaningful error toast
      const msg = err.name === 'AbortError' ? 'Substitution timed out' : (err.message || 'Substitution failed');
      toast.error(msg);
      console.error("Substitution error:", err);
    } finally {
      // Fix #3: Loading ALWAYS clears regardless of success/failure
      setIsLoadingTwo(false);
      setDraggedPlayerTeamTwo(null);
      setTargetedPlayerTeamTwo(null);
    }
  };

  const [{ isOver }, drop] = useDrop({
    accept: "teamTwoPlayer",
    drop: (item) => { handlePlayerTeamTwoDrop(item.player, player); },
    collect: (monitor) => ({ isOver: !!monitor.isOver() }),
  });

  return (
    <button
      ref={(isLoadingTwo && draggedPlayerTeamTwo == player.jersey_number) ? null : drop}
      onClick={() => handlePlayerSelectionTwo(playerId)}
      className={`relative lg:max-w-[108.26px] max-w-[44px] w-full lg:h-[148px] h-[60.15px] cursor-pointer  `}
      disabled={
        (isLoadingTwo && draggedPlayerTeamTwo == player.jersey_number) ||
        (isLoadingTwo && targetedPlayerTeamTwo === player.jersey_number) ||
        (actionPlayerId === player.roster_id && assistSelections) ||
        (actionPlayerId !== player.roster_id && shortSelections) ||
        (actionPlayerId === player.roster_id && shortSelections || shortFieldSelections)
      }
    >

     {
        player?.captain && (
          <div className="absolute top-[7px] md:top-[22px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
            c
          </div>
        )
      }

      {/* Loader Display */}
      {isLoadingTwo && draggedPlayerTeamTwo == player.jersey_number ? (
        <div className="absolute flex justify-center z-10 items-center left-0 top-0 bottom-0 right-0">
          <SpinnerLoaderBlack />
        </div>
      ) : isLoadingTwo && targetedPlayerTeamTwo === player.jersey_number && <div className="absolute flex justify-center z-10 items-center left-0 top-0 bottom-0 right-0">
        <SpinnerLoaderBlack />
      </div>}

      {/* Assist Selections Display */}
      {actionPlayerId === player.roster_id && assistSelections && (
        <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
      )}

      {/* Short Selections Display */}
      {actionPlayerId !== player.roster_id &&
        (shortSelections || shortFieldSelections) && (
          <div className="w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}
      {actionPlayerId === player.roster_id &&
        (shortSelections || shortFieldSelections) && (
          <div className="w-full bg-transparent cursor-not-allowed h-full absolute top-0 right-0 left-0 bottom-0 z-30"></div>
        )}

      {/* Player Icon */}
      <IconCollection
        name="player-jersey-white"
        svgFillColor={teamTwoColor}
        customClass="lg:w-[108.26px] w-[44px] w-full lg:h-[148px] h-[60.15px]"
      />

      {/* Player Jersey Number */}
      <p
        className={`font-bebas lg:text-[64px] text-[28px] text-white absolute lg:top-[30px] top-[12px] right-0 left-0 text-center`}
      >
        {player.jersey_number}
      </p>

      {/* Player Foul Count */}
      <div className="absolute lg:top-[115px] top-[46px] right-0 left-0 justify-center flex lg:gap-[2px] gap-[.81px] items-center">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className={`border-[.67px] rounded-full lg:w-2 lg:h-2 w-[3.25px] h-[3.25px]`}
            style={{
              background:
                index < playerPersonalFoulCount(event_team_b_id, player?.roster_id)
                  ? "white"
                  : "transparent",
              borderColor:
                index < playerPersonalFoulCount(event_team_b_id, player?.roster_id)
                  ? "white"
                  : "white",
            }}
          ></div>
        ))}
      </div>
    </button>
  );
};

export default DroppableTeamTwoPlayer;
